import { render, staticRenderFns } from "./cCreateDocLinks.vue?vue&type=template&id=070e71a5&scoped=true"
import script from "./cCreateDocLinks.vue?vue&type=script&lang=js"
export * from "./cCreateDocLinks.vue?vue&type=script&lang=js"
import style0 from "./cCreateDocLinks.vue?vue&type=style&index=0&id=070e71a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e71a5",
  null
  
)

export default component.exports